import { t } from "i18next";
import React from "react";
import { useNavigate } from "react-router-dom";
import "simplebar-react/dist/simplebar.min.css";

import type { ICustomerQuery } from "@repo/shopify/queries/customer-gql";

import Button from "@atoms/Button";

import { MEMBERSHIP_TABLE } from "@const/constant";
import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";

import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

export default function Membership() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  const { openAccount } = useLayoutStore();

  const { customer } = useCustomerStore();

  const handleMembership = (_accessToken?: string, fetchedCustomer?: ICustomerQuery["customer"]) => {
    const _customer = fetchedCustomer ?? customer;
    if (!_customer?.id) {
      sessionStorage.setItem("loginAfterUrl", URLS.ACCOUNT);
      openAccount(true);
      return;
    }

    navigate(URLS.ACCOUNT);
  };

  return (
    <>
      <h2 className="text-title pc:col-span-10 pc:flex col-span-8 hidden">Membership</h2>
      <section className="pc:col-span-10 col-span-8 grid grid-cols-subgrid gap-y-10 wrap-break-word">
        <article className="pc:col-span-3 col-span-8 flex flex-col gap-2.5 leading-5">
          <p>{t("contact.membership")}</p>

          <Button
            as="square"
            onClick={() => {
              handleMembership();
            }}
            variant="secondary"
          >
            {t("contact.my_membership")}
          </Button>
        </article>

        <section className="pc:col-span-5 col-span-8 grid grid-cols-subgrid gap-y-10">
          <section className="pc:col-span-6 col-span-8 grid h-fit grid-cols-subgrid gap-y-2.5">
            <span className="pc:col-span-6 col-span-8">Benefit Guide</span>

            <article className="pc:col-span-6 pc:grid-cols-5 col-span-8 grid grid-cols-subgrid gap-y-2.5">
              {MEMBERSHIP_TABLE.map((item) => (
                <div className="pc:col-span-6 pc:p-5 col-span-8 grid grid-cols-subgrid gap-y-1 bg-[#ECECEC] p-4" key={item.membership}>
                  <span className="pc:col-span-1 col-span-2">{item.membership}</span>
                  <div className="pc:col-span-2 col-span-6 flex flex-col">
                    <span>{item.benefits}</span>
                    <span>{item.discount_code}</span>
                  </div>
                  <span className="pc:col-span-2 pc:justify-end pc:flex pc:col-start-4 col-span-6 col-start-3">{item.purchase_amount}</span>
                </div>
              ))}
            </article>
          </section>

          <section className="pc:col-span-5 col-span-8 grid h-fit grid-cols-subgrid gap-y-2.5">
            <span className="pc:col-span-1 col-span-8">Policy</span>
            <ul className="font-features-normal pc:col-span-4 col-span-8 flex list-disc flex-col gap-1 pl-4 leading-5">
              <li>{t("account.membership.policy.1")}</li>
              <li>{t("account.membership.policy.2")}</li>
              <li>{t("account.membership.policy.3")}</li>
              <li>{t("account.membership.policy.4")}</li>
              <li>{t("account.membership.policy.5")}</li>
              <li>{t("account.membership.policy.6")}</li>
              <li>{t("account.membership.policy.7")}</li>
              <li>{t("account.membership.policy.8")}</li>
              <li>{t("account.membership.policy.9")}</li>
              <li>{t("account.membership.policy.10")}</li>
              {lang === "en" && <li>{t("account.membership.policy.11")}</li>}
            </ul>
          </section>
        </section>
      </section>
    </>
  );
}
